const state = {
  checkVAT: null,
  VATLoaded: false,
  VATRate: 0.19
}

const mutations = {
  'SET_VAT' (state, VATinfo) {
    state.checkVAT = VATinfo
    state.VATLoaded = true
  },
  'SET_VATLOADED_DEFAULT' (state) {
    state.VATLoaded = false
  },
  'SET_VAT_RATE' (state, vat) {
    const rate = parseFloat(vat)
    state.VATRate = rate > 1 ? rate / 100 : rate
  }
}

const actions = {
  setVAT: ({ commit }, VATinfo) => {
    commit('SET_VAT', VATinfo)
  },
  setVATLoadedDefault: ({ commit }) => {
    commit('SET_VATLOADED_DEFAULT')
  },
  setVatRateFromBasics: ({ commit }, vat) => {
    commit('SET_VAT_RATE', vat)
  }
}

const getters = {
  checkVAT: state => {
    return state.checkVAT
  },
  VATLoaded: state => {
    return state.VATLoaded
  },
  VATRate: state => {
    return state.VATRate
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
